import { useMutation } from "@tanstack/react-query";
import { axios } from "./axios";
import { useAuth } from "../context/AuthContext";
import { env } from "../utils/env";

interface Params {
  orders: { id: number | string; order: number }[];
}

export const useUpdateSectorOrder = () => {
  const { authHeader } = useAuth();

  return useMutation((params: Params) =>
    axios.post(
      `${env.verifyServiceUrl}individual/business_sector_risk_level/order/`,
      params,
      { headers: { Authorization: authHeader } }
    )
  );
};
